/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const linkChildOrganisationDataSchema = z.object({
	childId: z.string().uuid(),
})

export type LinkChildOrganisationDataSchema = z.infer<typeof linkChildOrganisationDataSchema>
